import React, { useContext, useState } from "react";
import PropTypes from "prop-types";

import { ConfirmationModal } from "components/ConfirmationModal";

import {
  HubContext,
  ToasterContext,
} from "scenes/Hubly/components/Workspace/Provider";
import { ShareResourcesModal } from "scenes/Settings/components/SharedResources/components";

import { ProcessModal } from "..";
import { GatedTemplateModal } from "../GatedTemplateModal";

export function ProcessSettingModal({
  process,
  showEdit,
  showDelete,
  showGatedTemplate,
  showShareProcess,
  onCreateProcess,
  onUpdateProcess,
  onDeleteProcess,
  onCreateTemplate,
  onShareProcess,
  onClose,
}) {
  const { addProcess, editProcess, deleteProcess } = useContext(HubContext);
  const { fireError } = useContext(ToasterContext);
  const [loading, setLoading] = useState(false);

  const removeProcess = ({ id }) => {
    setLoading(true);
    deleteProcess(id)
      .then(() => {
        onClose();
        onDeleteProcess(id);
      })
      .catch((error) => {
        fireError(
          error?.response?.data?.message || "Failed to delete process.",
          error
        );
        onClose();
      });
  };

  const createProcess = (createdProcess) => {
    setLoading(true);
    addProcess(createdProcess)
      .then(({ id }) => {
        onClose();
        onCreateProcess({ id: id, ...createdProcess });
      })
      .catch((error) => {
        fireError("Failed to create process.", error);
      });
  };

  const updateProcess = ({ savedProcess }) => {
    setLoading(true);
    editProcess(savedProcess.id, savedProcess)
      .then(() => {
        onClose();
        onUpdateProcess(savedProcess);
      })
      .catch((error) => {
        fireError("Failed to configure process.", error);
        onClose();
      });
  };

  return (
    <React.Fragment>
      {showEdit && (
        <ProcessModal
          loading={loading}
          process={process}
          onClosed={() => {
            onClose();
          }}
          onSaved={({ created, savedProcess }) => {
            if (created) {
              createProcess(savedProcess);
            } else {
              updateProcess({ savedProcess });
            }
          }}
        />
      )}
      {showDelete && process && (
        <ConfirmationModal
          title="Delete Process"
          message={`This will delete "${process.name}". This cannot be undone.`}
          icon="delete"
          buttons={[
            {
              text: "Cancel",
              callBack: () => {
                onClose();
              },
            },
            {
              text: "Delete",
              callBack: () => {
                removeProcess(process);
              },
              color: "red",
            },
          ]}
        />
      )}
      {showShareProcess && process && (
        <ShareResourcesModal
          isModalOpen
          process={{ ...process, id: process.globalId }}
          onSubmit={() => {
            onShareProcess();
            onClose();
          }}
          onClose={onClose}
        />
      )}
      {showGatedTemplate && process && (
        <GatedTemplateModal
          process={process}
          onSubmit={onCreateTemplate}
          onClose={onClose}
        />
      )}
    </React.Fragment>
  );
}

ProcessSettingModal.defaultProps = {
  process: null,
};

ProcessSettingModal.propTypes = {
  process: PropTypes.object,
  showEdit: PropTypes.bool.isRequired,
  showDelete: PropTypes.bool.isRequired,
  showGatedTemplate: PropTypes.bool.isRequired,
  showShareProcess: PropTypes.bool.isRequired,
  onUpdateProcess: PropTypes.func.isRequired,
  onDeleteProcess: PropTypes.func.isRequired,
  onCreateProcess: PropTypes.func.isRequired,
  onCreateTemplate: PropTypes.func.isRequired,
  onShareProcess: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ProcessSettingModal;
